module.exports = __webpack_public_path__ + "img/0Q3B8222_WoodMatted_MockedUp.ab70f124.jpg";